import useMobile from "src/hooks/useMobile";
import useScrollToSection from "src/hooks/useScrollToSection";

interface ScrollToSectionProps {
  targetId: string;
  enabled?: boolean;
}

const ScrollToSection: React.FC<ScrollToSectionProps> = ({
  targetId,
  enabled = true,
}) => {
  const { isMobile } = useMobile();

  // useScrollToSection(targetId, isMobile && enabled);

  return null;
};

export default ScrollToSection;
